/**
 * Get current time in milliseconds for Egypt local time
 * @returns Current timestamp in milliseconds as string
 */
export const getCurrentMillis = (): string => {
  // Egypt is UTC+2 (or UTC+3 during daylight saving time)
  // We'll use UTC+2 as the standard time
  const now = new Date();
  const egyptOffset = 2 * 60; // 2 hours in minutes
  const utc = now.getTime() + (now.getTimezoneOffset() * 60000);
  const egyptTime = new Date(utc + (egyptOffset * 60000));
  
  return egyptTime.getTime().toString();
};

/**
 * Get current time in milliseconds for Egypt local time (alternative implementation)
 * @returns Current timestamp in milliseconds as string
 */
export const getCurrentMillisAlternative = (): string => {
  // Using Intl.DateTimeFormat to get Egypt timezone
  const now = new Date();
  const egyptTime = new Date(now.toLocaleString("en-GB", {timeZone: "Africa/Cairo"}));
  
  return egyptTime.getTime().toString();
};

/**
 * Convert a Date object to Egypt local time milliseconds string
 * @param date - Date object to convert
 * @returns Timestamp in milliseconds as string
 */
export const dateToEgyptMillis = (date: Date): string => {
  const egyptOffset = 2 * 60; // 2 hours in minutes
  const utc = date.getTime() + (date.getTimezoneOffset() * 60000);
  const egyptTime = new Date(utc + (egyptOffset * 60000));
  
  return egyptTime.getTime().toString();
};
